export default "__VITE_ASSET__DVkPlP_E__"